export default __webpack_public_path__ + "static/media/whatsapp.84e133be.svg";